export default __webpack_public_path__ + "static/Corporate_Responsibility_ReponsibleSourcing_11-b38840e237d8fc3f90b4a3fdced54228.jpg";